import { CardData } from '../card-data';
import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import { VariantType } from '../../enum/dto/variant-type.enum';

export class GlassHouseBrandGroupCardData extends CardData {
  /**
   * GlassHouseBrandGroupCardData inception. Each card is represented by a GlassHouseBrandGroupCardData, and then
   * each row item is represented by the lineItems array, which are also GlassHouseBrandGroupCardData objects.
   */
  public lineItems: GlassHouseBrandGroupCardData[];

  /**
   * ⚠️ WARNING: This method is also used as the price override in the Glass House Price component.
   * Modifying it will affect the "Out the Door" price displayed on the card.
   */
  override getOverridePriceStreamForLabelComponent(): LocationPriceStream {
    return LocationPriceStream.TaxesIn;
  }

  getProductGroupingDescription(): string | null {
    return this.product?.description || this.firstRowVariantDescription();
  }

  private firstRowVariantDescription(): string | null {
    const firstVariant = this.rowVariants?.firstOrNull();
    return firstVariant?.shortDescription || firstVariant?.description || null;
  }

  /**
   * Due to regulatory requirements, Glass House cannot use the term “Disposable Vape” on printed materials
   * and requires the wording to be displayed as “All In One Vape.”
   */
  override rowVariantType(): VariantType | null {
    const type = super.rowVariantType();
    if (type === VariantType.DisposableVape) {
      return 'All In One Vape' as VariantType;
    }
    return type;
  }
}
